<template>
  <div>
    <div class="row justify-content-between">
      <div class="col-auto"></div>
      <div class="col-auto">
        <button
          @click="$router.push({ name: 'consignment-costs-create' })"
          class="btn btn-primary"
        >
          <i class="bi bi-plus-square"></i>
          Créer
        </button>
        <button @click="refresh()" class="btn btn0 btn-secondary">
          <i class="bi bi-arrow-clockwise"></i>Actualiser
        </button>
      </div>
    </div>

    <vue-data-table :headers="headers" :data="consignmentCosts" :items-per-page="10" :buttons="buttons"
      :summable-columns="summableColumns">

      <template #cell-totalPriceTTC="{ row }">
        <span class="px-2 py-1 rounded "
          :class="row.totalPriceTTC > 0 ? 'bg-light-primary text-primary' : 'bg-light-danger text-danger'">
          {{ row.totalPriceTTC }}
        </span>
      </template>

      <template #cell-totalPriceHT="{ row }">
        <span class="px-2 py-1 rounded "
          :class="row.totalPriceHT > 0 ? 'bg-light-primary text-primary' : 'bg-light-danger text-danger'">
          {{ row.totalPriceHT }}
        </span>
      </template>

      <template #cell-totalPriceTVA="{ row }">
        <span class="px-2 py-1 rounded "
          :class="row.totalPriceTVA > 0 ? 'bg-light-primary text-primary' : 'bg-light-danger text-danger'">
          {{ row.totalPriceTVA }}
        </span>
      </template>

      <template #footer-totalPriceTTC="{ column, sum }">
        <span class="fw-bold text-success">
          {{ sum }}
        </span>
      </template>

    </vue-data-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      headers: [
        { field: 'cost_reference', label: 'Référence facture', class: '' },
        { field: 'consignmentFullName', label: 'Consignment', class: '' },
        { field: 'totalPriceTTC', label: 'Total TTC', class: 'fw-bold', isAmount: true },
        { field: 'totalPriceHT', label: 'Total HT', class: 'fw-bold', isAmount: true },
        { field: 'totalPriceTVA', label: 'Total TVA', class: 'fw-bold', isAmount: true },
        { field: 'tva', label: 'TVA %', class: '' },
        { field: 'paymentMethod', label: 'Méthode de paiement', class: '' },
        { field: 'paymentDate', label: 'Date de paiement', class: '' },
        { field: 'userFullName', label: 'Créer par', class: '' },
      ],
      buttons: [
        {
          label: 'Modifier',
          icon: 'bi bi-pencil',
          class: 'btn btn-warning',
          action: (item) => {
            this.editCost(item);
          },
        },
        {
          label: 'Supprimer',
          icon: 'bi bi-trash',
          class: 'btn btn-danger',
          action: (item) => {
            this.deleteCost(item);
          },
        },
      ],
      summableColumns: [
        { field: 'totalPriceTTC', class: 'fw-bold' },
        { field: 'totalPriceHT', class: 'fw-bold' },
        { field: 'totalPriceTVA', class: 'fw-bold' },
      ],
    };
  },
  computed: {
    ...mapGetters("consignment", {
      consignmentCosts: "getAllCosts",
    }),
  },
  mounted() {
    this.$store.dispatch("consignment/getAllCosts");
  },
  methods: {
    async refresh() {
      return await this.$store.dispatch("consignment/getAllCosts");
    },
    async editCost(item) {
      this.$router.push({
        name: 'consignment-costs-edit',
        params: { reference: item.reference }
      });
    },
    async deleteCost(item) {
      await this.$store.dispatch("consignment/destroyCost", item.reference);
    },
  },
};
</script>

